import React from "react";
import { FiltersTypes } from "@common/types/filters/general";
import {
    AmountRoundingLevel,
    ROUNDING_LEVEL_LABELS,
} from "@common/types/transactionRule";

interface Props {
    filters: Pick<FiltersTypes, "amountRounded" | "amountRoundingLevel">;
}

export const RoundingFilterLabel: React.FC<Props> = ({
    filters: { amountRounded, amountRoundingLevel },
}) => {
    if (amountRounded === true) {
        const level = amountRoundingLevel ?? AmountRoundingLevel.DOLLAR;
        return <>Rounded {ROUNDING_LEVEL_LABELS[level]}</>;
    }

    if (amountRounded === false) {
        return <>Not rounded</>;
    }

    return null;
};
